import { Button } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { FormattedMessage } from 'react-intl';
import { useMutation } from 'react-query';

interface Props {
  userId: string;
  documentId: string;
  onDeleteSuccess: () => void;
}

export default function DocumentDeleteButton({ userId, documentId, onDeleteSuccess }: Props) {
  const { request } = useAuth();
  const deleteDocumentMutation = useMutation(() => request.delete(`/user/${userId}/documents/${documentId}`), {
    onSuccess: onDeleteSuccess
  });

  return (
    <Button
      sx={{ whiteSpace: 'nowrap' }}
      variant="outlined"
      onClick={() => deleteDocumentMutation.mutate()}
      disabled={deleteDocumentMutation.isLoading}
    >
      <FormattedMessage defaultMessage="Delete" />
    </Button>
  );
}
